import { REGEX_CONSTANT } from "../../../../constant/regexConstant";

export const validCompletion = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "email":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      }else if (!REGEX_CONSTANT.EMAIL.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
      // case "birth_date":
      //   if (!data) {
      //     error[namespace] = translate("COMMON:REQUIRE", {
      //       field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
      //     });
      //   } else {
      //     error[namespace] = null;
      //   }
      //   break;
        case "company_title":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "company_name":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "company_phone":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        }else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
          error[namespace] = translate("Invalid Format", {
            field: translate("Role ID"),
          });
        } else if (data.length > 12 || data.length < 10) {
          error[namespace] = translate("Field cannot be less than 10 and more than 12", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "company_country":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "company_province":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        } else {
          error[namespace] = null;
        }
        break;
        case "company_address":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        } else {
          error[namespace] = null;
        }
        break;
    default:
      break;
  }
  return error;
};
